<template>
  <div style="display: flex; flex-direction: column">
    <div style="text-align: right">
      <el-button
        type="primary"
        :disabled="disabled"
        style="min-width:50px;margin-right: 5px"
        @click="onClear"
      >{{ $t('SeaExport.Reset') }}
      </el-button>
      <el-dropdown
        :disabled="disabled"
        split-button
        type="primary"
        @click="commandHandle(command)"
        @command="p=>{command=p;commandHandle(command)}"
      >
        {{ command }}
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="$t('SeaExport.CopyMblConsignee')">{{ $t('SeaExport.CopyMblConsignee') }}</el-dropdown-item>
          <el-dropdown-item :command="$t('SeaExport.CopyNominatedAgentInfo')">{{ $t('SeaExport.CopyNominatedAgentInfo') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <cargo-input
      v-for="i in 7"
      :key="i"
      v-model="cargoDoc['agentPartyLine'+i]"
      :use-read-only="true"
      :disabled="disabled"
      :auto-uppercase="autoUppercase"
      style="margin-top: 5px"
      @change="onChange('agentPartyLine'+i)"
      @dblclick.native="showAdvanceTextDialog($t('SeaExport.AgentParty'),mergeAgentPartyLine(),splitAgentPartyLine,autoUppercase,{autoHalfWord:true,autoUppercase:autoUppercase})"
    />

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="disabled"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="!disabled"
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'SeHblAgentPart',
  components: { cargoInput, cargoAdvanceSelect, cargoRichTextarea },
  props: {
    job: { type: Object, default: () => { return {} } },
    cargoDoc: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false },
    autoUppercase: { type: Boolean, default: false }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      command: this.$t('SeaExport.CopyMblConsignee'),
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      }
    }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.cargoDoc[key] }])
    },
    onClear() {
      this.cargoDoc.agentPartyLine1 = ''
      this.cargoDoc.agentPartyLine2 = ''
      this.cargoDoc.agentPartyLine3 = ''
      this.cargoDoc.agentPartyLine4 = ''
      this.cargoDoc.agentPartyLine5 = ''
      this.cargoDoc.agentPartyLine6 = ''
      this.cargoDoc.agentPartyLine7 = ''
      this.changeAllItem(this.cargoDoc)
    },
    changeAllItem(form) {
      const items = []
      for (let i = 1; i <= 7; i++) {
        items.push({ key: `agentPartyLine${i}`, value: form[`agentPartyLine${i}`] })
      }
      this.$emit('childrenChange', items)
    },
    // 下拉菜单
    commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.CopyMblConsignee'):
          this.onCopy_agentParty()
          break
        case this.$t('SeaExport.CopyNominatedAgentInfo'):
          this.onCopy_designationAgent()
          break
      }
    },
    // 复制主单收货人
    async onCopy_agentParty() {
      const seaCargoDoc = this.job.seaCargoDoc || this.job.seaCargoDocs
      const mdoc = seaCargoDoc ? seaCargoDoc.find(doc => doc.docType === 'MBL') : null
      if (mdoc) {
        this.cargoDoc.agentPartyLine1 = mdoc.consigneeLine1
        this.cargoDoc.agentPartyLine2 = mdoc.consigneeLine2
        this.cargoDoc.agentPartyLine3 = mdoc.consigneeLine3
        this.cargoDoc.agentPartyLine4 = mdoc.consigneeLine4
        this.cargoDoc.agentPartyLine5 = mdoc.consigneeLine5
        this.cargoDoc.agentPartyLine6 = mdoc.consigneeLine6
        this.cargoDoc.agentPartyLine7 = mdoc.consigneeLine7
        this.changeAllItem(this.cargoDoc)
      }
    },
    /**
   * 取指定货代理信息
   */
    onCopy_designationAgent() {
      const cpy = Company.getCompanyById(this.job.designationAgent)
      if (cpy) {
        new Company(cpy).getOverseaAgentDetail().then(data => {
          this.loadDestinationAgentHandler(data)
        })
      }
    },
    loadDestinationAgentHandler(overseaAgentDetail) {
      if (overseaAgentDetail) {
        this.cargoDoc.agentPartyLine1 = overseaAgentDetail.blAddress
        this.cargoDoc.agentPartyLine2 = overseaAgentDetail.blAddressLine2
        this.cargoDoc.agentPartyLine3 = overseaAgentDetail.blAddressLine3
        this.cargoDoc.agentPartyLine4 = overseaAgentDetail.blAddressLine4
        this.cargoDoc.agentPartyLine5 = overseaAgentDetail.blAddressLine5
        this.cargoDoc.agentPartyLine6 = overseaAgentDetail.blAddressLine6
        this.cargoDoc.agentPartyLine7 = overseaAgentDetail.blAddressLine7
        this.changeAllItem(this.cargoDoc)
      }
    },
    // 高级文本弹框相关方法
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      // 关闭弹框时的清理工作
    },
    // 合并代理方地址行
    mergeAgentPartyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.cargoDoc['agentPartyLine' + i] || ''
        result += '\n'
      }
      result += (this.cargoDoc['agentPartyLine7'] || '')
      return result.trimEnd()
    },
    // 分割代理方地址行
    splitAgentPartyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.cargoDoc['agentPartyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.cargoDoc['agentPartyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.cargoDoc['agentPartyLine' + i] = ''
      }

      // 通知父组件数据变更
      this.changeAllItem(this.cargoDoc)
    }
  }
}
</script>
